module.exports = {"title":"系统维护","content":"由于中国移动香港服务系统于2020年12月9日23:30 - 2020年12月10日07:00进行提升工程，我们暂时无法提供部份通讯服务包括：账户登录、缴付账单、储值卡增值、国际漫游、购买额外数据、申请增值服务、服务计划升级及其他业务查询服务。如有紧急查询，请致电中国移动香港客户服务热线29458888，不便之处，敬请原谅。\n"}


//////////////////
// WEBPACK FOOTER
// ./src/locale/SystemMaintenance/zh-cn.json
// module id = J3Tc
// module chunks = 1